<div class="overlay" [class.is-enabled]="enabled()" (click)="clicked.emit()" (wheel)="scrollUnderOverlay($event)"></div>
